import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DownloadPageSize, DropdownStatusList, FilterPaymentTypeOptions, FormTypeEdit, PageSize, PaymentTypeOptions, RentalOptions, RentalStatusOptions, ReturnConditionOptions } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { DateFormat, DateShort, GetStatus, money } from "utils/helpers"
import { useModal } from "context/ModalContext";
import DatePicker from "components/Input/DatePicker";
import { FilterCard, FormCard, MainBodyCard, PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { RentalOrderService } from "services/RentalOrderService/RentalOrderService";
import DataTable from "components/DataTable";
import GridDeleteButton from "components/Button/GridDeleteButton";
import { exportRentalOrderToPdf } from "utils/export/ExportRental";
import PrintButton from "components/Button/PrintButton";

export default function TransactionRental() {
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchRentalOrderList, fetchReturnRental, fetchDeliverRental } = RentalOrderService()

    const [filterDateFrom, setFilterDateFrom] = useState(new Date())
    const [filterDateTo, setFilterDateTo] = useState(new Date())

    const [rentalOrderList, setRentalOrderList] = useState([])
    const [customerName, setCustomerName] = useState('')
    const [rentalStatus, setRentalStatus] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [transactionType, setTransactionType] = useState('1')
    const [selectedRentalReturn, setSelectedRentalReturn] = useState({})
    const [returnCondition, setReturnCondition] = useState('')
    const [returnNotes, setReturnNotes] = useState('')
    const [returnDate, setReturnDate] = useState(new Date())
    const [showModalRentalReturn, setShowModalRentalReturn] = useState(false)
    const [paymentType, setPaymentType] = useState(FilterPaymentTypeOptions[0].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "orderDate",
            header: "Tanggal",
            render: (row) => DateShort(row.rentalDate),
        },
        {
            key: "customerName",
            header: "Pelanggan"
        },
        {
            key: "brandName",
            header: "Item",
            render: (row) => row.brandName + ' ' + row.productName,
        },
        {
            key: "quantity",
            header: "Durasi",
            render: (row) => row.quantity + ' ' + RentalOptions.find(x => x.value === String(row.rentalOptions)).label,
        },
        {
            key: "nettAmount",
            header: "Jumlah",
            render: (row) => 'Rp ' + money(row.nettAmount),
        },
        {
            key: "paymentType",
            header: "Metode Pembayaran",
            render: (row) => PaymentTypeOptions.find(x => x.value === String(row.paymentType)).label,
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <GridDeleteButton
                    isActive={row.status}
                    onClick={(e) => {
                        e.stopPropagation();
                        deleteBtnClick(row.orderId, row.status);
                    }}
                    size='w-3'
                />
            ),
        },
    ]

    // Button Event
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()

        if (!onConfirm) return

        showLoading()

        try {

        }
        finally {
            hideLoading()
        }
    }
    const transactionClick = (id) => {
        navigate("/transaction-detail?orderId=" + id + "&transactionType=" + transactionType + "&formType=" + FormTypeEdit)
    }
    const rentalReturnBtnClick = async (id) => {
        showLoading()

        try {
            let res = await fetchReturnRental(id, returnCondition, returnNotes, returnDate)
            if (!res) return

            handlePageChange(0)
        }
        finally {
            hideLoading()
        }
    }
    const exportPdfBtnClick = async () => {
        showLoading()

        try {
            const res = await fetchRentalOrderList(DateFormat(filterDateFrom), DateFormat(filterDateTo), customerName, rentalStatus, paymentType, status, DownloadPageSize, 0, '')
            if (!res) return

            exportRentalOrderToPdf(res?.data?.listData ?? [], {
                totalAmount: res?.data?.totalAmount,
                dateFrom: filterDateFrom,
                dateTo: filterDateTo,
            });
        }
        finally {
            hideLoading()
        }
    };
    // Function Grid
    const handlePageChange = async (newIndex) => {
        const res = await fetchRentalOrderList(DateFormat(filterDateFrom), DateFormat(filterDateTo), customerName, rentalStatus, paymentType, status, PageSize, newIndex, '')
        if (!res) return

        const totalData = res?.data?.totalData ?? 0;
        const total = Math.max(1, Math.ceil(totalData / PageSize))

        setRentalOrderList(res)
        setTotalPages(total)
        setPageIndex(newIndex)
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                await handlePageChange(0)
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    }, [filterDateFrom, filterDateTo, paymentType, status, transactionType, rentalStatus, customerName])

    return (
        <MainBodyCard>
            <PagesTitle title='Rental' />

            <div className="flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-4 w-full mt-4">
                <FilterCard title='Date From' width='w-full sm:w-56'>
                    <DatePicker value={filterDateFrom} onChange={setFilterDateFrom} disableClock={true} />
                </FilterCard>

                <FilterCard title='Date To' width='w-full sm:w-56'>
                    <DatePicker value={filterDateTo} onChange={setFilterDateTo} disableClock={true} />
                </FilterCard>

                <FilterCard title='Customer Name' width='w-full sm:w-56'>
                    <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} />
                </FilterCard>

                <FilterCard title='Payment Type' width='w-full sm:w-48'>
                    <Dropdown value={paymentType} options={FilterPaymentTypeOptions} onChange={(e) => { setPaymentType(e.value) }} placeholder='All' />
                </FilterCard>

                <FilterCard title='Status' width='w-full sm:w-36'>
                    <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                </FilterCard>
                <div className="flex items-end">
                    <PrintButton
                        className="px-4 py-2 rounded-full border bg-white hover:bg-slate-100 whitespace-nowrap"
                        onClick={exportPdfBtnClick}
                    >
                        Export PDF
                    </PrintButton>
                </div>
            </div>

            <div className="flex gap-2 bg-white p-2 shadow-sm rounded-lg border mt-5">
                <div className="flex gap-2">
                    {/* <div className="border-x mx-4" /> */}
                    {RentalStatusOptions.map((x, i) =>
                        <button key={i}
                            className={`${rentalStatus === x.value ? 'bg-black text-white' : 'bg-white text-black'}
                                px-3 py-1 rounded-full border text-sm
                            `}
                            onClick={() => { setRentalStatus(x.value) }}
                        >
                            {x.label}
                        </button>
                    )}
                </div>
            </div>

            <div className="hidden sm:block mt-5">
                <DataTable
                    columns={columns}
                    data={rentalOrderList?.data?.listData ?? []}
                    onRowClick={(row) => transactionClick(row.rentalOrderId)}
                    footer={
                        <tr className="h-10">
                            <td colSpan={5} className="text-right px-2">
                                <span className="font-semibold">Total</span>
                            </td>
                            <td colSpan={4} className="px-2">
                                <span className="font-semibold">
                                    Rp {money(String(rentalOrderList?.data?.totalAmount))}
                                </span>
                            </td>
                        </tr>
                    }
                />
            </div>

            <div className="sm:hidden mt-4 flex flex-col gap-3">
                {
                    rentalOrderList?.data?.listData?.length === 0 ? (
                        <div className="text-center h-12">
                            <span>No Data Available</span>
                        </div>
                    ) :

                        rentalOrderList?.data?.listData?.map((data, i) => {
                            return (
                                <div className="p-2 border rounded-lg hover:bg-slate-100" key={i} onClick={() => { transactionClick(data.rentalOrderId) }}>
                                    <div className="flex justify-between">
                                        <span>#{data.rentalOrderId} </span>
                                        <span>{DateShort(data.orderDate)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>{data.customerName}</span>
                                        <span>Rp {money(data.nettAmount)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>{data.quantity + ' ' + RentalOptions.find(x => x.value === String(data.rentalOptions)).label}</span>
                                        <span>{PaymentTypeOptions.find((x) => x.value === String(data.paymentType))?.label}</span>
                                    </div>
                                </div>
                            )
                        })
                }
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />

            {/* MODAL RENTAL RETURN */}
            {showModalRentalReturn && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">

                    {/* BACKDROP */}
                    <div
                        className="absolute inset-0 bg-black/50"
                        onClick={() => setShowModalRentalReturn(false)}
                    />

                    {/* MODAL BOX */}
                    <div className="relative overflow-auto bg-white rounded-xl shadow-lg lg:w-9/12 xl:w-8/12 2xl:w-6/12 p-6 max-h-[90vh] overflow-y-auto">
                        <h2 className="text-xl font-semibold mb-3">
                            Rental Item Return
                        </h2>

                        <div className="flex flex-col gap-3">
                            <FormCard title='Customer'>
                                <span>{selectedRentalReturn.customerName}</span>
                            </FormCard>

                            <FormCard title='Item'>
                                <span>{selectedRentalReturn.brandName} - {selectedRentalReturn.productName}</span>
                            </FormCard>

                            <FormCard title='Return Date'>
                                <DatePicker className='' value={returnDate} onChange={setReturnDate} />
                            </FormCard>

                            <FormCard title='Return Condition'>
                                <div className="flex gap-2">
                                    {ReturnConditionOptions.map((data, i) => {
                                        return (
                                            <button className={`rounded-full border px-3 py-1 ${data.value === '' ? 'hidden' : 'block'} ${data.value === returnCondition ? 'bg-black text-white' : 'bg-white text-black'}`}
                                                onClick={() => setReturnCondition(data.value)}
                                            >
                                                {data.label}
                                            </button>
                                        )
                                    })}
                                </div>
                            </FormCard>

                            <FormCard title='Return Notes'>
                                <input className="input" value={returnNotes} onChange={(e) => setReturnNotes(e.target.value)} />
                            </FormCard>

                        </div>

                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-2 rounded-full border"
                                onClick={() => setShowModalRentalReturn(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="px-4 py-2 rounded-full bg-black text-white"
                                onClick={() => {
                                    rentalReturnBtnClick(selectedRentalReturn.rentalOrderId);
                                    setShowModalRentalReturn(false);
                                }}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </MainBodyCard>
    )
}
